const DEFAULT_PAGESIZE = 10;

export const paginationInitialState = {
  currentPage: 1,
  pageSize: DEFAULT_PAGESIZE,
  totalCount: 1,
  totalPages: 1,
};
